type Props = {
  className?: string
}

export const TypingSvg = ({ className }: Props) => (
  <svg
    width="28"
    height="15"
    viewBox="0 0 28 15"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="8" cy="10" r="2">
      <animate
        attributeName="cy"
        values="10;6;10"
        dur="1.2s"
        repeatCount="indefinite"
      />
      <animate
        attributeName="fill"
        values="currentColor;lightgray;currentColor"
        dur="1.2s"
        repeatCount="indefinite"
      />
    </circle>
    <circle cx="16" cy="10" r="2">
      <animate
        attributeName="cy"
        values="10;6;10"
        dur="1.2s"
        begin="0.4s"
        repeatCount="indefinite"
      />
      <animate
        attributeName="fill"
        values="currentColor;lightgray;currentColor"
        dur="1.2s"
        begin="0.4s"
        repeatCount="indefinite"
      />
    </circle>
    <circle cx="24" cy="10" r="2">
      <animate
        attributeName="cy"
        values="10;6;10"
        dur="1.2s"
        begin="0.8s"
        repeatCount="indefinite"
      />
      <animate
        attributeName="fill"
        values="currentColor;lightgray;currentColor"
        dur="1.2s"
        begin="0.8s"
        repeatCount="indefinite"
      />
    </circle>
  </svg>
)
